import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function Btn({ to, href, children, variant = "primary", className = "", ...props }) {
  const base = "inline-flex items-center gap-2 px-7 py-3.5 rounded-full text-sm font-semibold transition-all group";
  const styles = variant === "primary"
    ? "btn-primary hover:opacity-90 hover:-translate-y-0.5 soft-shadow"
    : "btn-grid-outline hover:-translate-y-0.5";
  const cls = `${base} ${styles} ${className}`;
  const inner = (
    <>
      {children}
      <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
    </>
  );
  if (to) return <Link to={to} className={cls} {...props}>{inner}</Link>;
  return <a href={href} className={cls} {...props}>{inner}</a>;
}

export function SectionLabel({ children, num }) {
  return <IdentityLabel kicker={num}>{children}</IdentityLabel>;
}

export function IdentityLabel({ children, kicker, className = "", ...props }) {
  return (
    <div className={`mb-6 flex min-h-8 w-fit items-stretch gap-3 ${className}`} data-ui="identity-label" {...props}>
      <span className="w-[3px] rounded-full bg-primary" aria-hidden="true" />
      <span className="flex flex-col justify-center gap-0.5">
        {kicker && <span className="text-[8px] font-semibold uppercase tracking-[0.24em] text-muted-foreground">{kicker}</span>}
        <span className="font-display text-sm font-semibold leading-tight tracking-tight text-foreground">{children}</span>
      </span>
    </div>
  );
}

export function MetaTag({ children, className = "", ...props }) {
  return <span className={`meta-tag ${className}`} {...props}>{children}</span>;
}

export function FieldLabel({ children, className = "", ...props }) {
  return <label className={`field-label ${className}`} {...props}>{children}</label>;
}
